import React from 'react';
import { Button, ButtonGroup } from '@mui/material';

interface ButtonGroupComponentProps {
  state: {
    [key: string]: boolean;
  };
  setState: React.Dispatch<any>;
}

const ButtonGroupComponent = ({ state, setState }: ButtonGroupComponentProps) => {
  const SetValue = (state: any, KEY: string) => {
    Object.keys(state).forEach((key) => {
      if (key === KEY) {
        state[KEY] = true;
      } else {
        state[key] = false;
      }
    });

    return state;
  };

  return (
    <>
      <ButtonGroup aria-label="button group" fullWidth>
        {Object.keys(state).map((key) => (
          <Button
            variant={state[key] ? 'contained' : 'outlined'}
            key={key}
            onClick={() => {
              const results = SetValue(state, key);
              setState({ ...results });
            }}>
            {key}
          </Button>
        ))}
      </ButtonGroup>
    </>
  );
};

export default ButtonGroupComponent;
